import React, {useEffect, useState} from 'react';
import './pizzaButton.scss';

const handleClick = (e, link) => {
  e.preventDefault();
  if (link){
    window.open(link, 'mywindow');
  }
}

const PizzaButton = (props: PizzaButtonInterface) => {

  const {
      iconOpen,
      iconClose,
      data
  } = props

  const [open, setOpen] = useState(false);

  useEffect(() => {
    let webchat: any = document.getElementById("cai-webchat-div");
    if (open) {
      webchat?.setAttribute("class", "--visible");
    } else {
      webchat?.setAttribute("class", "--no-visible");
    }
  }, [open])

  return (
    <div className="m-circularMenu">
      <div
        onClick={() => setOpen(false)}
        className={`m-circularMenu__background ${open ? `--active` : ""}`}
      >
      </div>
      <div
        onClick={() => setOpen(!open)}
        className={`m-circularMenu__btn ${open ? `--opened` : ""}`}
      >
        {open ? <img src={iconClose && iconClose} alt='Cerrar Menú' /> : <img src={iconOpen} alt='Abrir Menú' /> }
      </div>
      <div className={`m-circularMenu__buttons ${open ? `--active` : ""}`}>
          {
            data.map((btn: any) => (
              <div className="m-circularMenu__buttons__btn" key={btn.nombre}>
                <div className="m-circularMenu__buttons__btn__name">
                  <span>{btn.nombre}</span>
                </div>
                <div className="m-circularMenu__buttons__btn__icon" onClick={(e) => handleClick(e, btn.link)}>
                  {btn.icono ? 
                    <i className={`icon-${btn.icono}`}></i>
                    : btn.iconoImagen ?
                    <img src={btn.iconoImagen && btn.iconoImagen.file.url} alt={btn.nombre} /> : null
                  }
                </div>
              </div>
            ))
          }
        </div>
    </div>


  );
}

interface PizzaButtonInterface {
    iconOpen: string;
    iconClose: string;
    data: any;
 }

export default PizzaButton;
